import { useId, useState } from "react";
import { t, useLocale } from "@/i18n/locale";
import { Message } from "@/i18n/Message";
/** The bar shows only the clock (mm:ss, e.g. "04:59"); the "Trial · … left"
 *  wording and the save explanation live in the tooltip so the surface stays
 *  quiet and the timer itself is unambiguous. */
export default function PublicTrialCountdown({ seconds }: { seconds: number | null | undefined }) {
  useLocale();
  const id = useId();
  const [open, setOpen] = useState(false);
  if (seconds == null || !Number.isFinite(seconds)) return null;
  const remaining = Math.max(0, Math.ceil(seconds));
  const clock = `${String(Math.floor(remaining / 60)).padStart(2, "0")}:${String(remaining % 60).padStart(2, "0")}`;
  return <span className="discovery-trial-help" onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
    <span role="timer" aria-live="off" aria-label={t("Public trial: {{value0}} remaining", { value0: clock })}>
      <button type="button" className="discovery-trial-countdown" aria-describedby={open ? id : undefined} aria-expanded={open}
        onFocus={() => setOpen(true)} onBlur={() => setOpen(false)} onClick={() => setOpen(true)} onKeyDown={event => { if (event.key === "Escape") setOpen(false); }}>
        {clock}
      </button>
    </span>
    {open ? <span className="discovery-trial-tooltip" id={id} role="tooltip">
      <Message message="Trial · {{value0}} remaining" values={{ value0: clock }} />{" "}
      <Message message="Add your own copy to Library" />. <Message message="Your work in this Try will not be carried over." />
    </span> : null}
  </span>;
}
